import { logUserDataResponseError } from './processResponse';
import {
    Category,
    RequestType,
    UserDataItem,
    UserDataItemProperty,
    UserDataStore,
} from '../data/schema/UserDataStoreSchema';
import { format } from 'owa-localize';
import { makeGetRequest } from 'owa-ows-gateway';

const GET_USER_DATA_ITEMS_NAME = 'GetUserDataItems';
const GET_USER_DATA_ITEMS_URL: string = 'ows/v1.5/UserDataStore/items';
const GET_USER_DATA_ITEMS_BY_CATEGORY_URL: string =
    'ows/v1.5/UserDataStore/items?requestType={0}&categoryId={1}';

/**
 * Retrieve the UserData collection for the current user, it should contains all
 * the stored info for the user.
 */
export async function getUserDataItemsService(
    requestType: RequestType,
    categoryId?: string
): Promise<UserDataStore[]> {
    try {
        const apiUrl =
            categoryId?.trim().length == 0
                ? format(GET_USER_DATA_ITEMS_URL, requestType)
                : format(GET_USER_DATA_ITEMS_BY_CATEGORY_URL, requestType, categoryId);
        const response = await makeGetRequest(apiUrl);
        return Promise.resolve(convertResponseToUserDataStores(response));
    } catch (error) {
        logUserDataResponseError(GET_USER_DATA_ITEMS_NAME, error?.message);
        return Promise.resolve(null);
    }
}

function convertResponseToUserDataStores(response: any): [UserDataStore] {
    return response.map(
        data =>
            <UserDataStore>{
                category: <Category>{
                    id: data.categoryID,
                    name: data.category,
                },
                userDataItems: data.userDataInfoList.map(
                    item =>
                        <UserDataItem>{
                            id: item.id,
                            categoryName: data.category,
                            categoryId: data.categoryID,
                            key: item.key,
                            value: item.value,
                            dataSource: item.dataSource,
                            property: <UserDataItemProperty>{
                                creationTimeUTC: item.createdDateTime,
                                lastModifiedTimeUTC: item.updatedDateTime,
                                isPinned: item.isPinned,
                            },
                        }
                ),
            }
    );
}
